import { render, staticRenderFns } from "./SettingsCard.vue?vue&type=template&id=36201058&scoped=true&"
import script from "./SettingsCard.vue?vue&type=script&lang=js&"
export * from "./SettingsCard.vue?vue&type=script&lang=js&"
import style0 from "@/assets/less/manage-space/base.less?vue&type=style&index=0&id=36201058&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36201058",
  null
  
)

export default component.exports